export const phoneRegexp = /^\+[0-9]{10,15}$/;
